module.exports = __webpack_public_path__ + "01_glasses_brown.07d31621.png";


//////////////////
// WEBPACK FOOTER
// ./src/imgs/custom/momoro/girl/layer4/01_glasses_brown.png
// module id = OYbh
// module chunks = 0